/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'big_arrow': {
    width: 17,
    height: 16,
    viewBox: '0 0 17 16',
    data: '<path pid="0" d="M16.5 7H4.33l5.59-5.59L8.5 0l-8 8 8 8 1.41-1.41L4.33 9H16.5V7z" _fill="#00395C" fill-opacity=".8"/>'
  }
})
